/**
 * Takes a background color as input and returns either a light or
 * dark color depending on the brightness of the background color.
 * @param {string} bgColor - String that represents the background
 * color in either hexadecimal format (e.g., "#ffffff") or without
 * the "#" symbol (e.g., "ffffff").
 * @param [lightColor=#fff] - Optional parameter that represents the
 * color to be used for the text when the background color is
 * considered light.
 * @param [darkColor=#000] - The `darkColor` parameter is the color that
 * will be returned if the calculated text color is dark.
 * @returns The color of the text that should be used based on the background color.
 *
 * Thanks: https://stackoverflow.com/questions/3942878/how-to-decide-font-color-in-white-or-black-depending-on-background-color
 */
export function getColorByBgColor(
  bgColor,
  lightColor = "#fff",
  darkColor = "#000"
) {
  const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  const textColor =
    r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
  return textColor;
}
